import React, { Suspense } from "react";

const Loadable = (Component, customFallback = null) => (props) => (
  <Suspense
    fallback={
      customFallback || (
        <div
          style={{
            minHeight: "100vh",
            background: "#F4F7FB",
            width: "100%",
          }}
        />
      )
    }
  >
    <Component {...props} />
  </Suspense>
);

export default Loadable;